(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/store/redux.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/store/redux.js');

'use strict';

const _svs$accountservicesR = svs.accountservicesReact.deposit.store.deposit,
  depositReducer = _svs$accountservicesR.reducer,
  despositInitialState = _svs$accountservicesR.initialState;
const _svs$accountservicesR2 = svs.accountservicesReact.deposit.store.swish,
  swishReducer = _svs$accountservicesR2.reducer,
  swishInitialState = _svs$accountservicesR2.initialState;
const reducerObject = {
  deposit: depositReducer,
  swish: swishReducer
};

svs.accountservicesReact.deposit.store.createStore = function () {
  let preloaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return RTK.configureStore({
    reducer: reducerObject,
    preloadedState: preloaded
  });
};

const store = svs.accountservicesReact.deposit.store.createStore({
  deposit: despositInitialState,
  swish: swishInitialState
});
const DepositReduxProvider = _ref => {
  let children = _ref.children;
  return React.createElement(ReactRedux.Provider, {
    store: store
  }, children);
};
svs.accountservicesReact.deposit.store.DepositReduxProvider = DepositReduxProvider;

 })(window);